import  { VISUALIZAR_LOADING, VISUALIZAR_MENU, VISUALIZAR_ALERTA } from './actionTypes';

export const cambiar_VisualizacionLoading = (isVisibleLoading) => {
    return {    type: VISUALIZAR_LOADING,
                isVisibleLoading    }		
}

export const cambiar_VisualizacionMenu = (isVisibleMenu) => {
    return {    type: VISUALIZAR_MENU,
                isVisibleMenu    }		
}

export const visualizarAlerta = (configAlerta) => {
    return {    type: VISUALIZAR_ALERTA,
                data: configAlerta    }
}

export const visualizarAlertaDeError = (titulo, mensaje) => {
    return {type: VISUALIZAR_ALERTA, data: {isVisible: true, tipo: 'error', titulo, mensaje}};
}

export const visualizarAlertaDeInforme = (titulo, mensaje) => {
    return {type: VISUALIZAR_ALERTA, data: {isVisible: true, tipo: 'info', titulo, mensaje}};
}